/** Site-wide SEO / contact / lead-gen constants. */

export const SITE_URL = (
    process.env.REACT_APP_SITE_URL || "https://www.reflexologue-savoie.com"
).replace(/\/$/, "");

export const SITE_NAME = "Joëlle Berthaud — Réflexologue";

export const SITE_DEFAULT_TITLE =
    "Réflexologue à Challes-les-Eaux (Savoie) | Joëlle Berthaud";

export const SITE_DEFAULT_DESCRIPTION =
    "Joëlle Berthaud, réflexologue certifiée à Challes-les-Eaux en Savoie. Réflexologie plantaire, palmaire, faciale Dien Chan et Chan'Beauté. Prendre rendez-vous au 06 63 34 03 97.";

/** OG JPEG compressé (<200 Ko) — crawlers sociaux. WebP aussi dispo. */
export const OG_IMAGE_PATH = "/og-image.jpg";

/**
 * URL fiche Google (adresse précise — plus stable qu'une recherche vague).
 * Remplace par l'URL « Partager » de la fiche Google Business Profile dès qu'elle est dispo.
 */
export const GOOGLE_MAPS_URL =
    process.env.REACT_APP_GOOGLE_MAPS_URL ||
    "https://www.google.com/maps/search/?api=1&query=Jo%C3%ABlle+Berthaud%2C+1981+Route+Royale%2C+73190+Challes-les-Eaux";

/** Liens d'entité pour schema sameAs (annuaires / présence). */
export const SOCIAL_SAME_AS = [
    SITE_URL,
    GOOGLE_MAPS_URL,
    "https://www.pagesjaunes.fr/pros/61369584",
    "https://naetur.co/praticien/berthaud-joelle-reflexologue-challes-les-eaux-savoie-challes-les-eaux",
].filter(Boolean);

/** OpenStreetMap marker — 1981 Route Royale, Challes-les-Eaux */
export const GEO = {
    latitude: 45.541046,
    longitude: 5.98827,
};

export const FORM_ENDPOINT =
    process.env.REACT_APP_FORM_ENDPOINT ||
    `https://formsubmit.co/ajax/joelleberthaud@reflexologue-savoie.com`;

/** WhatsApp — même numéro que le téléphone cabinet (sans +). */
export const WHATSAPP_NUMBER = (
    process.env.REACT_APP_WHATSAPP_NUMBER || "33663340397"
).replace(/\D/g, "");

export const WHATSAPP_PREFILL =
    "Bonjour, j'étais sur le site de votre cabinet, et je souhaiterais prendre rendez-vous s'il vous plaît.";

export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_PREFILL)}`;

/**
 * Hébergeur (Mentions légales). Remplir via env à la mise en prod.
 */
export const HOSTING = {
    name: process.env.REACT_APP_HOSTING_NAME || "",
    address: process.env.REACT_APP_HOSTING_ADDRESS || "",
    contact: process.env.REACT_APP_HOSTING_CONTACT || "",
    url: process.env.REACT_APP_HOSTING_URL || "",
};
